import type { AxiosPromise } from "axios";
import { httpClient } from "src/shared/services/httpClient";

export interface EmpaGetResponse {
  errorMsg?: string;
  previousAnswers?: {
    isEmpa?: boolean;
    q1?: boolean;
    q2?: boolean;
    q3?: boolean;
    q4?: boolean;
    q5?: boolean;
    q6?: boolean;
  };
}

export function fetchEmpaFormData(): AxiosPromise<EmpaGetResponse> {
  return httpClient.get("/empa/form");
}

export const submitEmpaForm = (formData: FormData) =>
  httpClient.post("/empa/submission", formData);
